const REPO_BASE =
  'https://github.com/md-global-continence/wifi-test-suite/blob/main';

export function AboutPage() {
  return (
    <main className="main">
      <section className="section">
        <h2>About</h2>
        <p>
          The Soluu WiFi Test Harness is a diagnostic tool for the Soluu
          medical device. It pairs a browser-based Web Bluetooth client with
          an optional Raspberry Pi serving as a configurable WPA2 access
          point, so the same UI covers both field tests (a tester walks up to
          a real network) and bench tests (a Pi runs through named regulatory
          scenarios).
        </p>
        <p>
          The harness is <strong>not</strong> a certified test instrument and
          does not implement the Soluu's unlock cipher. Logs are JSON,
          accumulated in this browser's localStorage, and exportable from the
          Settings page or the home screen.
        </p>
      </section>

      <section className="section">
        <h2>Quickstart</h2>
        <ol>
          <li>Power on a Soluu within Bluetooth range.</li>
          <li>
            On the <strong>Home</strong> page, click <strong>Connect</strong>{' '}
            and pick the device from the OS chooser.
          </li>
          <li>
            Type the WiFi <strong>SSID</strong> and <strong>password</strong>;
            click <strong>Connect to WiFi</strong>.
          </li>
          <li>
            Watch the <strong>Live Status</strong> timeline. A run is{' '}
            <strong>pass</strong> only when it reaches{' '}
            <code>ON_INTERNET</code>; <code>CONNECTED</code> alone is not
            enough.
          </li>
        </ol>
        <p>
          Stuck at <code>CONNECTED</code> and timing out? The device probably
          can't reach the <em>status endpoint</em> — change it on the{' '}
          <strong>Settings</strong> page (the Settings page is mostly for
          driving a Raspberry Pi rig, but it also has the knobs you'd reach
          for when the Home page doesn't behave).
        </p>
        <p>
          Full walk-through:{' '}
          <a
            href={`${REPO_BASE}/docs/user-guide.md`}
            target="_blank"
            rel="noreferrer"
          >
            User Guide
          </a>{' '}
          — covers status labels, result types, the diagnostics panel, when to
          open Settings, and common gotchas.
        </p>
      </section>

      <section className="section">
        <h2>References</h2>
        <ul>
          <li>
            <a
              href={`${REPO_BASE}/SPEC.md`}
              target="_blank"
              rel="noreferrer"
            >
              SPEC.md
            </a>{' '}
            — product contract.
          </li>
          <li>
            <a
              href={`${REPO_BASE}/docs/user-guide.md`}
              target="_blank"
              rel="noreferrer"
            >
              User Guide
            </a>{' '}
            — how to use this harness and read its output.
          </li>
          <li>
            Browser support: Chromium-based browsers — Chrome, Edge, or
            Brave. Windows is the field-confirmed configuration; macOS and
            Linux Chrome should work but aren't part of our test loop.
            Firefox, Safari (any platform), and iOS browsers are not
            supported because they don't ship Web Bluetooth.
          </li>
        </ul>
      </section>
    </main>
  );
}
